import { render } from "./EmailAuth.vue?vue&type=template&id=42d376b2&scoped=true"
import script from "./EmailAuth.vue?vue&type=script&lang=js"
export * from "./EmailAuth.vue?vue&type=script&lang=js"

import "./EmailAuth.vue?vue&type=style&index=0&id=42d376b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d376b2"]])

export default __exports__